import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Receitas',
    path: '/financial/incomes',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
